import Cookies from 'js-cookie';

const user = {
    state: {
        isLogin: false,
        userInfo: '',
    },
    mutations: {
        getInfo (state, vm) {
            let userInfo = Cookies.get('user');
            return userInfo;
        },
        login (state, vm) {
            this.state.isLogin = true;
        },
        logout (state, vm) {
            this.state.isLogin = false;
            this.state.userInfo = '';
            Cookies.remove('user');
            Cookies.remove('permission');
            // 恢复默认样式
            let themeLink = document.querySelector('link[name="theme"]');
            themeLink.setAttribute('href', '');
            // 清空打开的页面等数据，但是保存主题数据
            let theme = '';
            if (localStorage.theme) {
                theme = localStorage.theme;
            }
            localStorage.clear();
            if (theme) {
                localStorage.theme = theme;
            }
            window.location.reload();
        }
    }
};

export default user;



// WEBPACK FOOTER //
// src/store/modules/user.js